import {
	Component,
	Input,
	EventEmitter,
	Output
} from "@angular/core";

import { IdService } from "../shared/services/id.service";


@Component({
	selector: "rbc-block",
	template: `
		<section [id]="id" [ngClass]="classGen()" class="rbc-block">
			<div [ngClass]="{ container: container }">
				<div
					*ngIf="floatingHeader"
					class="rbc-block-floating-header"
					[ngClass]="
						floatingHeaderColor ? 'b-' + floatingHeaderColor : null
					"
				>
					<span
						[id]="id + 'FloatingHeader'"
						class="rbc-block-floating-header-text"
						[innerHtml]="floatingHeader"></span>
				</div>
				<hr *ngIf="divider" class="rbc-block-divider">
				<div [ngClass]="{ 'well': well }">
					<header
						*ngIf="title || text"
						[ngClass]="headerClassGen()"
						class="row rbc-block-header"
					>
						<div
							[ngClass]="[
								headerColumns
									? 'col-lg-' + headerColumns
									: ctaLabel
									? 'col-12'
									: 'col-lg-' + columns
							]"
						>
							<div class="row">
								<h2
									*ngIf="title"
									[id]="id + 'Header'"
									[ngClass]="[
										ctaLabel ? 'col-lg-8' : 'col-12'
									]"
									class="rbc-block-header-title"
								>
									{{ title }}
								</h2>
								<div
									*ngIf="ctaLabel"
									class="col-lg-4 text-lg-right text-left mb-half mb-lg-0"
								>
									<a
										[id]="id + 'CTA'"
										[href]="ctaLink"
										class="link-chev">
										<span [innerHtml]="ctaLabel"></span>

										<rbc-icon icon="angle-right"></rbc-icon>
									</a>
								</div>
							</div>

							<div
								*ngIf="text"
								class="rbc-block-header-description"
							>
								<ng-container select="[description]">
								<div [id]="id + 'Text'" >
									{{ text }}
								</div>
								</ng-container>
							</div>
							<ng-content select="[header]"></ng-content>
						</div>
					</header>

					<div
						[ngClass]="{
							'justify-content-center': columnsCentered
						}"
						class="row"
					>
						<div [ngClass]="columnClassGen()">
							<ng-content></ng-content>

							<rbc-expandable
								*ngIf="disclaimerTriggerLabel"
								[childId]="id + 'Disclaimer'"
								[arrow]="true"
								[expanded]="disclaimerOpen"
								arrowPosition="left"
								class="rbc-block-spacer-t-sm"
							>
								<h3 trigger
									[id]="id + 'DisclaimerTrigger'"
									[innerHtml]="disclaimerTriggerLabel">
								</h3>
								<ng-content select="[disclaimer]"></ng-content>
							</rbc-expandable>
						</div>
					</div>
					<footer
						*ngIf="footerCtaLabel"
						[ngClass]="footerClassGen()"
						class="rbc-block-footer row"
					>
						<div [ngClass]="['col-lg-' + columns]">
							<ng-content select="[footer]"></ng-content>
							<ng-container *ngIf="footerCtaButton; else anchorLink">
							<rbc-button
									*ngIf="footerCtaLabel"
									[id]="id + 'FooterCTA'"
									[outline]="true"
									[ngClass]="[
										footerCtaButton
											? 'rbc-block-footer-button'
											: 'link-chev'
									]"
									[link]="
										footerCtaButton && footerCtaLink
											? footerCtaLink
											: null
									"
									color="primary"
									(click)="footerLinkClick()"
								>
									{{ footerCtaLabel }}
									<rbc-icon
										[attr.aria-hidden]="true"
										icon="angle-right"
									></rbc-icon>
								</rbc-button>
							</ng-container>

							<ng-template #anchorLink>
								<a
									*ngIf="footerCtaLabel"
									[id]="id + 'FooterCTA'"
									outline
									[ngClass]="[
										footerCtaButton
											? 'rbc-block-footer-button'
											: 'link-chev'
									]"
									[href]="footerCtaLink"
									color="primary"
									(click)="footerLinkClick()"
								>
									{{ footerCtaLabel }}
									<rbc-icon
										[attr.aria-hidden]="true"
										icon="angle-right"
									></rbc-icon>
								</a>
							</ng-template>
						</div>
					</footer>
				</div>
				<hr *ngIf="dividerBottom" class="rbc-block-divider-bottom">
			</div>
		</section>
	`,
	styles: []
})
export class BlockComponent {
	@Input() id: string;
	@Input() title;
	@Input() text;
	@Input() ctaLink: string;
	@Input() ctaLabel: string;
	@Input() divider: boolean;
	@Input() dividerBottom: boolean;
	@Input() grey: boolean;
	@Input() well: boolean;
	@Input() small: boolean;
	@Input() headerCentered: boolean;
	@Input() headerFlush: boolean;
	@Input() headerColumns: number;
	@Input() container;
	@Input() flush: boolean;
	@Input() floatingHeader: string;
	@Input() floatingHeaderColor: string;
	@Input() columns = 12;
	@Input() columnsCentered: boolean;
	@Input() disclaimerTriggerLabel = "Disclaimer";
	@Input() disclaimerOpen: boolean;
	@Input() footerCtaLink: string;
	@Input() footerCtaLabel: string;
	@Input() footerCtaButton: boolean;
	@Input() footerCtaAlign = "center";

	@Output() footerlinkclicked = new EventEmitter();

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	classGen() {
		return {
			"rbc-block-grey": this.grey,
			"rbc-block-well": !this.container && this.grey,
			"rbc-block-flush-top": this.divider || this.floatingHeader,
			"rbc-block-flush-bottom": this.dividerBottom,
			"rbc-block-flush": this.flush,
			"rbc-block-small": !this.container || this.small
		};
	}
	headerClassGen() {
		return {
			"text-center": this.headerCentered && !this.ctaLabel,
			"justify-content-center":
				this.headerCentered || this.columnsCentered,
			"rbc-block-header-flush": this.headerFlush
		};
	}
	footerClassGen() {
		return {
			"justify-content-center": this.columnsCentered,
			"text-left": this.footerCtaAlign === "left"
		};
	}

	columnClassGen() {
		let classes = {};
		if (!this.columns) {
			this.columns = 12;
		}
		classes["col-lg-" + this.columns] = this.columns;
		return classes;
	}

	footerLinkClick() {
		this.footerlinkclicked.emit();
	}
}
